import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../_environments/environment';
import { CouponcodeCode } from '../_model/couponcode';
import { UrlParameters } from '../_model/shared';
import { Originentitytype } from '../_model/subscription';
import { Snackbarerrorformat, Snackbarformat } from '../_theme/snackbarformats';
import { LocalstorageService } from './LocalstorageService';
import { ToastService } from './Toast.service';
import { GlobalService } from './GlobalService';

@Injectable({ providedIn: 'root' })
export class CouponcodeService {

  private couponcode: CouponcodeCode = null;
  couponcode$: BehaviorSubject<CouponcodeCode> = new BehaviorSubject<CouponcodeCode>(null);

  private timeoutTime = 1500 //time to make sure it is always set on every object

  constructor(
    private _http: HttpClient,
    private _toastService: ToastService,
    private _localstorage: LocalstorageService,
    private _globalService: GlobalService,
  ) {
    this.couponcode = _localstorage.getObject('couponcode');
    // this.couponcode$ = new BehaviorSubject<CouponcodeCode>(this.couponcode);

    if (this.couponcode) {
      Promise.resolve().then(() => {
        this.couponcode$.next(this.couponcode);
      });
    }
  }

  setCouponcode(code: string, couponcode: CouponcodeCode = null, email: string = null) {

    if (!couponcode)
      couponcode = new CouponcodeCode(null, code, null, null, true, email, null);

    //readded ability to overwrite code by url for Elysee project 25-08-2025
    // if (this.couponcode !== null && this.couponcode.code) return;

    if (this._globalService.isInBrowser)
      if (!this.couponcode || couponcode.code !== this.couponcode?.code) {
        this._toastService.openWithTranslate('couponcode.code_added_to_session', 'common.ok_dismiss', Snackbarformat);
      } else {
        setTimeout(() => {
          this.couponcode$.next(this.couponcode);
        });
        return
      }

    this._localstorage.setObject('couponcode', couponcode);
    this.couponcode = couponcode;

    //promese.resolve didnt resolve and fire the couponcode$.next
    setTimeout(() => {
      this.couponcode$.next(this.couponcode);
    });

    // Promise.resolve().then(() => {

    // });


  }

  removeCouponcodeFromStorage() {
    this.couponcode = null;
    this.couponcode$.next(null);
    this._localstorage.removeItem('couponcode');
  }

  checkCouponcode(couponcode: string, customerid: number = null, email: string = null, orginentitytype: Originentitytype = null, applyCode: boolean = true): Observable<boolean> {
    if (!couponcode || couponcode === '') { return of(false) }

    const params = new UrlParameters();

    params.addParameter('couponcodecode', couponcode)
    if (email)
      params.addParameter('email', email)
    if (customerid)
      params.addParameter('customerid', customerid.toString())
    if (orginentitytype)
      params.addParameter('originentitytype', orginentitytype.toString())

    return this._http.get(environment.apiserver + 'couponcode/v1/couponcode/code/isvalidandusable' + params.toString()).pipe(
      map((response: boolean) => {
        if (applyCode && response)
          this.setCouponcode(couponcode)
        return response
      })
      , catchError(error => {
        if (error.status === 400) {
          return throwError(() => 'Bad request');
        }
        if (error.status === 404) {
          this.removeCouponcodeFromStorage();
          return throwError(() => {

            return 'Code not found'
          });
        }

        return throwError(() => error || 'Server error');
      })
    );
  }

  getMagentoCouponcode(magentoid: number): Observable<CouponcodeCode> {
    return this._http.get(environment.apiserver + 'couponcode/v1/couponcode/magentoid/' + magentoid).pipe(
      map((result: CouponcodeCode) => {
        if (result.isusable) {
          this.setCouponcode(null, result)
        } else {
          this._toastService.openWithTranslate('couponcode.code_not_valid', 'common.ok_dismiss', Snackbarerrorformat);
        }
        return result as CouponcodeCode
      })
      , catchError(this.handleError)
    );

  }

  private handleError(error: Response) {
    if (error.status === 400) return throwError(() => 'Bad request');
    if (error.status === 404) return throwError(() => 'Code not found');
    return throwError(() => error || 'Server error');
  }

}
